import { FC } from 'react';

/** Definition of a path segment of an SVG representing a region. */
export type RegionDefinition = {
  name: string;
  color: string;
  path: string;
};

/** Props definition for a map component. */
export type MapProps = {
  activeRegion: string | null;
  onBlur?: () => void;
  onHover?: (region: string) => void;
  regions: RegionDefinition[];
  viewBox: [number, number, number, number];
};

/** An SVG component representing a map of a country. */
export const Map: FC<MapProps> = ({ activeRegion, onBlur, onHover, regions, viewBox }) => {
  return (
    <svg width="100%" height="100%" viewBox={viewBox.join(' ')} version="1.1">
      {regions.map(({ color, name, path }) => (
        <path
          key={name}
          d={path}
          className={`${
            activeRegion && activeRegion !== name && 'opacity-30'
          } transition-opacity fill-current text-${color}-500`}
          onMouseEnter={() => onHover && onHover(name)}
          onMouseLeave={() => onBlur && onBlur()}
        />
      ))}
    </svg>
  );
};
